import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { faEllipsisH, faMicrophoneSlash, faMinusCircle, faThumbtack, faVideoSlash } from '@fortawesome/free-solid-svg-icons';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'app-meeting-participant-controls',
  templateUrl: './meeting-participant-controls.component.html',
  styleUrls: ['./meeting-participant-controls.component.scss']
})
export class MeetingParticipantControlsComponent implements OnInit, AfterViewInit {
  pinIcon = faThumbtack;
  kickIcon = faMinusCircle;
  micMuteIcon = faMicrophoneSlash;
  camMuteIcon = faVideoSlash;
  dots = faEllipsisH;
  @Input() show = false;
  @Output() pin = new EventEmitter<void>();
  @Output() micMute = new EventEmitter<void>();
  @Output() camOff = new EventEmitter<void>();
  @Output() cick = new EventEmitter<void>();
  @ViewChild(MatMenuTrigger, { static: false }) public menuTrigger: MatMenuTrigger;
  

  constructor() { }

  ngAfterViewInit() {
    this.menuTrigger.menuOpened.pipe(
      delay(200)
    ).subscribe((val) => {
      console.log(this.menuTrigger)
    });
  }

  menuOpened(event) {
    console.log('opened');
      var menu = document.getElementsByClassName('cdk-overlay-connected-position-bounding-box') as HTMLCollectionOf<HTMLElement>;
      
      menu[0].style.top = event.pageY - 5 + 'px';

  }

  ngOnInit(): void {
  }

  onPin(): void {
    this.pin.emit();
  }
  onMicMute(): void {
    this.micMute.emit();
  }
  onCamOff(): void {
    this.camOff.emit();
  }
  onCick(): void {
    this.cick.emit();
  }

}
